<template>
  <div class="block">
    <el-pagination
      v-if="total > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 30, 50, 100]"
      :page-size="pageSize"
      layout="->,total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import { savePageState } from "@/unit/pageStateStorage.js";

export default {
  inject: {
    mergeQueryCache: { default: null },
  },
  props: {
    total: {
      type: Number,
      default: 100,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageNum: {
      type: Number,
      default: 1,
    },
    cacheKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.ready = true;
    });
  },
  methods: {
    resolveCacheKey() {
      return this.cacheKey || (this.$route && this.$route.name) || "";
    },
    canPersist() {
      return this.ready && this.total > 0;
    },
    persistPage(partial) {
      const key = this.resolveCacheKey();
      if (!key) {
        return;
      }
      if (this.mergeQueryCache) {
        this.mergeQueryCache(key, partial);
      }
      savePageState(key, {
        pageNum:
          partial.pageNum != null ? partial.pageNum : this.pageNum,
        pageSize:
          partial.pageSize != null ? partial.pageSize : this.pageSize,
      });
    },
    handleSizeChange(val) {
      if (this.canPersist()) {
        this.persistPage({ pageSize: val, pageNum: 1 });
      }
      this.$emit("SizeChange", val);
    },
    handleCurrentChange(val) {
      if (val === this.pageNum) {
        return;
      }
      if (!this.canPersist()) {
        return;
      }
      this.persistPage({ pageNum: val });
      this.$emit("CurrentChange", val);
    },
  },
};
</script>
<style lang="less" scoped>
.block {
  padding-top: 10px;
}
</style>
